import { render, staticRenderFns } from "./PetTable.vue?vue&type=template&id=1f216a48&"
import script from "./PetTable.vue?vue&type=script&lang=js&"
export * from "./PetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports